import React from 'react';
import { Server } from '../../server/server';
import { checkNumber, getAssetImage } from '../util/util';
import './Modal.css'
import './PurchaseAssetModal.css'
import { Database } from '../../server/database';
import { AppConfig } from '../AppConfig';

interface PurchaseAssetModalProps {
  show: boolean,
  asset: string,
  onPurchase: Function;
  onCancel: Function;
}

interface PurchaseAssetModalState {
  paymentMethod: number
  quantity: number
  processing: boolean;
  message: string;
  message2: string;
  error: boolean;
}

class PurchaseAssetModal extends React.Component<PurchaseAssetModalProps, PurchaseAssetModalState> {
  protected tokensPerDollar:number = 100;
  protected coinsPerToken:number = 10;

  constructor(props: PurchaseAssetModalProps) {
    super(props);
    
    this.state = this.getInitialState();

    this.onQuantity = this.onQuantity.bind(this);
    this.onBuy = this.onBuy.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onMessageOk = this.onMessageOk.bind(this);
  }

  getInitialState():any {
    return {
      quantity: (this.props.asset == AppConfig.token.id) ? 100 : 1,
      paymentMethod: 0,
      processing: false,
      message: '',
      message2: '',
      error: false
    };
  }

  onQuantity(e: React.FormEvent<HTMLInputElement>) {
    let value = e.currentTarget.value;

    if (!checkNumber(value)) 
      return;
      
    let newQuantity = +value;
    this.setState({ quantity: newQuantity });

    // let value = e.currentTarget.value;
    // if (!checkNumber(value)) {
    //   return;
    // } else {
    //   let quantity = Number(value);
    //   let totalPrice = this.state.price * quantity;

    //   if (this.state.currency == 'coin' && totalPrice > this.state.balance) {
    //     this.setState({ error: 'Balance insufficient!', btnOkDisabled: true });
    //   } else {
    //     if (totalPrice == 0) {
    //       this.setState({ error: 'Quantity is zero.', btnOkDisabled: true });
    //     } else {
    //       this.setState({ error: '', btnOkDisabled: false });
    //     }
    //   }

    //   this.setState({ quantity: quantity, totalPrice: totalPrice });
    // }
  }

  onPayment(i:number) {
    this.setState({paymentMethod: i})
  }

  onCancel() {
    this.props.onCancel();
  }

  onMessageOk() {
    this.setState(this.getInitialState())
    if(this.state.error)
      this.props.onCancel();
    else
      this.props.onPurchase();
  }

  async onBuy() {
    // this.props.onPurchase(this.state.quantity, this.state.paymentMethod)
    this.setState({processing: true});

    let currency = 'coin';
    let shopAsset = Server.shop.getAsset(this.props.asset);

    if(this.props.asset == AppConfig.token.id)
      currency = (this.state.paymentMethod == 0) ? 'usd' : 'coin';
    else if(shopAsset) {
      currency = shopAsset.currency;
      if(currency == 'usd' || currency == AppConfig.token.id)
        currency = (this.state.paymentMethod == 0) ? 'usd' : AppConfig.token.id;
    }

    let response:any = null;
    if(this.props.asset == AppConfig.token.id)
      response = await Server.user.purchaseTokens(this.state.quantity, currency);
    else 
      response = await Server.user.purchaseAsset(this.props.asset, this.state.quantity, currency);

    let message = '';
    let message2 = '';

    if(response.success) {
      if(shopAsset && shopAsset.type == 'pack' && shopAsset.category == 'currency') 
        for (let i = 0; i < this.state.quantity; i++)
          await Server.user.openPack(this.props.asset);

      message = 'Purchase successful!';
      if(currency == 'usd') 
        message2 = 'The dollars spent with your fake credit card during this Alpha test period can be viewed in your Stats.'
    }
    else
      message = response.message;

    setTimeout(() => {
      this.setState({
        message: message,
        message2: message2,
        processing: false,
        error: !response.success
      });
    }, 1000);
  }

  renderPriceDiv(price:number, currency:string) {
    if(currency == 'usd') {
      return (
        <div className="shop-card-price">{'$' + price.toFixed(2)}</div>
      );
    }

    let icon = (currency == AppConfig.token.id) ? AppConfig.token.id : 'coin';

    return (
      <div className="shop-card-price">
        {price.toFixed(0)}&nbsp;<img className="shop-card-price-icon" src={'/assets/' + icon + '.png'} />
      </div>
    )
  }

  render() {
    if(!this.props.show) {
      return (<div></div>)
    }

    if(this.state.processing) {
      return (
        <div className="modal open">
          <div className="modal-content" style={{alignItems: 'center', width: '250px'}}>
            Processing..
          </div>
        </div>
      )
    }

    if(this.state.message != '') {
      return (
        <div className="modal open">
          <div className="modal-content" style={{alignItems: 'center', width: '300px'}}>
            <div style={{marginBottom: '20px', textAlign: 'center'}}>
              {this.state.message}
              {(this.state.message2 != '') && 
                <div style={{marginTop: '5px', color: '#ffffffa0'}}>{this.state.message2}</div>
              }
            </div>
            <button onClick={this.onMessageOk}>
                OK
            </button>
          </div>
        </div>
      )
    }

    let asset = Database.getAsset(this.props.asset);
    let shopAsset = Server.shop.getAsset(this.props.asset);

    let currency = '';
    let price = 0;

    if(shopAsset) {
      currency = shopAsset.currency;
      price = shopAsset.price;

      if(currency == 'usd') {
        if(this.state.paymentMethod == 1) {
          currency = AppConfig.token.id;
          price = this.tokensPerDollar * shopAsset.price;
        }
      }
    }
    else if(this.props.asset == AppConfig.token.id) {
      if(this.state.paymentMethod == 0) {
        currency = 'usd';
        price = 1/this.tokensPerDollar;
      }
      else {
        currency = 'coin';
        price = this.coinsPerToken;
      }
    }

    let paymentOptions = 1;
    let paymentName1 = 'Coin Balance';
    let paymentValue1 = Server.user.getCoinCount();
    let paymentCurrency1 = 'coin';
    let paymentName2 = '';
    let paymentValue2 = 0;
    let paymentCurrency2 = '';

    if(this.props.asset == AppConfig.token.id) {
      paymentOptions = 2;
      paymentName1 = 'Credit Card';
      paymentValue1 = 0;
      paymentCurrency1 = '';
      paymentName2 = 'Coin Balance';
      paymentValue2 = Server.user.getCoinCount();
      paymentCurrency2 = 'coin';
    }
    else if(currency == 'usd' || currency == AppConfig.token.id) {
      paymentOptions = 2;
      paymentName1 = 'Credit Card';
      paymentValue1 = 0;
      paymentCurrency1 = '';
      paymentName2 = AppConfig.token.symbol + ' Balance';
      paymentValue2 = Server.user.getTokenCount();
      paymentCurrency2 = AppConfig.token.id;
    }

    return (
      <div className="modal open">
        <div className="modal-content" onClick={e => e.stopPropagation()}>
          <div className="purchase-asset-modal">
            {asset.category == 'banner' ?
              <div className="purchase-asset-product-panel-banner">
                <div className="purchase-asset-product-name">{asset.name} Banner</div>
                <img className="purchase-asset-product-image-banner" src={getAssetImage(asset)} />
              </div>
              :
              <div className="purchase-asset-product-panel">
                <img className="purchase-asset-product-image" src={getAssetImage(asset)} />
                <div>
                  <div className="purchase-asset-product-name">{asset.name}</div>
                  <div className="purchase-asset-product-description">{asset.description}</div>
                </div>
              </div>
            }

            <div className="purchase-asset-quantity-panel">
              <div className="purchase-asset-quantity-row">
                <div>Unit Price</div>
                {this.renderPriceDiv(price, currency)}
              </div>
              <div className="purchase-asset-quantity-row">
                <div>Quantity</div>
                <div>
                  x <input className="purchase-asset-quantity-input" value={this.state.quantity} onChange={this.onQuantity} />
                </div>
              </div>
              {/* <div style={{backgroundColor: '#ffffff80', height: '1px', marginTop: '10px', marginBottom: '5px'}}></div> */}
              <div className="purchase-asset-quantity-row" style={{color: 'white'}}>
                <div>Total Price</div>
                {this.renderPriceDiv(price * this.state.quantity, currency)}
              </div>
            </div>

            {(paymentOptions == 1) &&
              <div className="purchase-asset-payment-panel">
                <div>{paymentName1}</div>
                {this.renderPriceDiv(paymentValue1, paymentCurrency1)}
              </div>
            }

            {(paymentOptions == 2) &&
              <div className="purchase-asset-payment-options-panel">
                <div>Select payment method:</div>

                <div className="purchase-asset-payment-options-row">
                  <div className="purchase-asset-payment-options-radio">
                    <input 
                      type="radio" 
                      name="payment" 
                      value="0"
                      checked={this.state.paymentMethod == 0}
                      onChange={()=>this.onPayment(0)}
                      className="purchase-asset-payment-options-radio-input"
                    />
                    &nbsp;<div onClick={()=>this.onPayment(0)}>{paymentName1}</div>
                  </div>
                  {paymentCurrency1 != '' && this.renderPriceDiv(paymentValue1, paymentCurrency1)}
                </div>

                <div className="purchase-asset-payment-options-row">
                  <div className="purchase-asset-payment-options-radio">
                    <input 
                      type="radio" 
                      name="payment" 
                      value="1"
                      checked={this.state.paymentMethod == 1}
                      onChange={()=>this.onPayment(1)}
                      className="purchase-asset-payment-options-radio-input"
                    />
                    &nbsp;<div onClick={()=>this.onPayment(1)}>{paymentName2}</div>
                  </div>
                  {paymentCurrency2 != '' && this.renderPriceDiv(paymentValue2, paymentCurrency2)}
                </div>

              </div>
            }

            <div className="purchase-asset-button-panel">
              <button className="purchase-asset-cancel-button" onClick={this.onCancel}>
                Cancel
              </button>
              <button onClick={this.onBuy}>
                Purchase
              </button>
            </div>

          </div>
        </div>
      </div>
    )
  }
}

export default PurchaseAssetModal;
